import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';


import App from './App';
import reportWebVitals from './reportWebVitals';
/* Mark iOS so CSS can drop the most expensive compositing there.
   Every browser on iPhone/iPad is WebKit (Apple requires it), so this is an
   ENGINE check, not a Safari check — Chrome and Firefox on iOS hit it too.
   WebKit re-rasterises a backdrop-filter's blurred backdrop on every frame
   that content moves behind it, which makes a fixed, blurred header and
   bottom nav expensive on every single scroll. Blink (Android) handles the
   same CSS far more cheaply, which is why only iPhones felt sluggish.
   iPadOS reports itself as a Mac, hence the touch-point check. */
const isIOS =
  /iP(hone|ad|od)/.test(navigator.userAgent) ||
  (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));
if (isIOS) document.documentElement.setAttribute("data-ios", "");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
